import styled, { css } from "styled-components"

export default {
    "Btn": styled.button`
        width: 100%;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        background-color: ${({ theme }) => theme.color.major};
        color: ${({ theme }) => theme.color.white};
        ${({ theme }) => theme.font.small_bold};
        border-radius: 8px;

        ${({ $minor }) => $minor && css`
            background-color: ${({ theme }) => theme.color.grey2};
            color: ${({ theme }) => theme.color.white};
        `}

        ${({ $deactive }) => $deactive && css`
            background-color: ${({ theme }) => theme.color.grey2};
            color: ${({ theme }) => theme.color.white};
            cursor: not-allowed;
        `}

        ${({ $small }) => $small && css`
            ${({ theme }) => theme.font.extra_small_bold};
            padding: 8px 16px;
        `}

        ${({ $fitWidth }) => $fitWidth && css`
            width: fit-content;
        `}

        ${({ $expandHeight }) => $expandHeight && css`
            height: 100%;
        `}
    `,
}